import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a405c7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shopping-cart-table" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"header hidden-xs-only\" data-v-8a405c7c><div class=\"product\" data-v-8a405c7c> Product </div><div class=\"other-box\" data-v-8a405c7c><div class=\"price\" data-v-8a405c7c> Price </div><div class=\"quantity\" data-v-8a405c7c> Quantity </div><div class=\"total\" data-v-8a405c7c> Total </div></div></div>", 1)
const _hoisted_3 = { class: "product-list" }
const _hoisted_4 = { class: "product" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  key: 0,
  class: "offline"
}
const _hoisted_9 = { class: "desc" }
const _hoisted_10 = { class: "desc type" }
const _hoisted_11 = { class: "mobile-price-quantity d-md-none" }
const _hoisted_12 = { class: "mobile-price" }
const _hoisted_13 = { class: "mobile-quantity" }
const _hoisted_14 = { class: "other-box hidden-xs-only" }
const _hoisted_15 = { class: "price" }
const _hoisted_16 = { class: "quantity" }
const _hoisted_17 = { class: "total" }
const _hoisted_18 = { class: "footer" }
const _hoisted_19 = { class: "code-box d-flex" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Apply discount code ")
const _hoisted_21 = { class: "total-box hidden-xs-only" }
const _hoisted_22 = { class: "total-money" }
const _hoisted_23 = { class: "oprtate-wrapper" }
const _hoisted_24 = { class: "select-total-container" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select all", -1))
const _hoisted_26 = { class: "total-box d-md-none" }
const _hoisted_27 = { class: "total-money" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" check out ")

import { ref, watch } from 'vue';
  import _ from 'lodash';
  import { ShoppingCartStore, CheckoutStore } from '@/stores';
  import { useRouter } from 'vue-router';

  interface IProps {
    store: ShoppingCartStore;
    checkoutStore: CheckoutStore;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    store: null,
    checkoutStore: null
  },
  setup(__props: any) {

const props = __props as {
    store: ShoppingCartStore;
    checkoutStore: CheckoutStore;
  }

  const router = useRouter();
  
  const code = ref('');

  const handleUpdateQuatity = _.debounce((id: number) => {
    props.store.updateCartItemQuatity(id);
  }, 500);

  // TODO:
  const handleApplyDiscount = () => {};

  const handleCalcTotal = _.debounce(() => {
    const { checkoutStore, store } = props;
    checkoutStore.lineItemsAttributes = store.getCheckedItems().map(item => _.pick(item, ['quantity', 'variant_id', 'purchase_kind']));
    checkoutStore.fetchData();
  }, 500);

  const handleCheckout = () => {
    router.push({ name: 'checkout.home', params: { ids: props.store.checkedIds.join(',') } });
  };

  watch(
    () => props.store.checkedQuantity,
    handleCalcTotal,
    { immediate: true }
  );


return (_ctx: any,_cache: any) => {
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppPrice = _resolveComponent("AppPrice")!
  const _component_AppStepper = _resolveComponent("AppStepper")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.store.data, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "item d-flex"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_AppCheckbox, {
                "increase-click-area": "",
                "model-value": __props.store.checkedIds.includes(item.id),
                disabled: !item.active,
                "onUpdate:modelValue": ($event: any) => (__props.store.toggleCartItemChecked(item.id))
              }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"]),
              _createElementVNode("img", {
                class: "banner",
                src: _unref(_).get(item, 'variant.product.images.0.url')
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(item.variant.name) + " ", 1),
                  (!item.active)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (已下架) "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.variant.product.description), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.purchase_kind), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_AppPrice, {
                      value: item.price
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_AppStepper, {
                      modelValue: item.quantity,
                      "onUpdate:modelValue": [($event: any) => ((item.quantity) = $event), ($event: any) => (_unref(handleUpdateQuatity)(item.id))],
                      min: 0
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_AppPrice, {
                  value: item.price
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_AppStepper, {
                  modelValue: item.quantity,
                  "onUpdate:modelValue": [($event: any) => ((item.quantity) = $event), ($event: any) => (_unref(handleUpdateQuatity)(item.id))],
                  min: 0
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_AppPrice, {
                  value: Number(item.price) * Number(item.quantity)
                }, null, 8, ["value"])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
          class: "code-input"
        }, null, 512), [
          [
            _vModelText,
            code.value,
            void 0,
            { trim: true }
          ]
        ]),
        _createVNode(_component_AppLoadingButton, {
          pill: "",
          variant: "outline-primary",
          onClick: handleApplyDiscount
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("span", null, "Subtotal (" + _toDisplayString(__props.store.checkedQuantity) + " items):", 1),
        _createElementVNode("span", _hoisted_22, [
          _createVNode(_component_AppPrice, {
            value: __props.checkoutStore.order.total
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", {
          class: "select-all",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.store.toggleCartItemCheckAll()))
        }, [
          _createVNode(_component_AppCheckbox, {
            class: "checkall",
            "model-value": __props.store.allChecked
          }, null, 8, ["model-value"]),
          _hoisted_25
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", null, "Subtotal (" + _toDisplayString(__props.store.checkedQuantity) + " items):", 1),
          _createElementVNode("span", _hoisted_27, [
            _createVNode(_component_AppPrice, {
              value: __props.checkoutStore.order.total
            }, null, 8, ["value"])
          ])
        ])
      ]),
      _createVNode(_component_AppLoadingButton, {
        pill: "",
        size: "lg",
        variant: "primary",
        disabled: !__props.store.checkedQuantity,
        onClick: handleCheckout
      }, {
        default: _withCtx(() => [
          _hoisted_28
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 64))
}
}

})